import { useMemo } from 'react';
import { RelationSelect } from './RelationSelect';
import { makeFetchPage, makeFetchRows } from '../relationConfigs';

/**
 * relationConfigs'teki bir config ile RelationSelect'i tek satırda kurar.
 * config: RELATION_CONFIGS.customer gibi STABİL bir referans olmalı (inline obje verme,
 * aksi halde sunucu modunda her render yeniden sorgular).
 *
 * Props:
 *   config        : RELATION_CONFIGS girişi (mode/columns/searchFields/getRowLabel/title içerir)
 *   value, selectedLabel, onChange(value,row)
 *   rows          : (istemci modu) zaten yüklü dizi varsa fetch yerine bunu kullan
 *   disabled, allowClear, title, placeholder, searchPlaceholder
 */
export function RelationPicker({
  config,
  rows,
  value,
  selectedLabel,
  onChange,
  disabled = false,
  allowClear = true,
  title,
  placeholder,
  searchPlaceholder,
  closeOnSelect = true,
  selectedValues,
  panelMinWidth,
  selectedCode,
  openToken,
}) {
  const server = config.mode === 'server';
  const fetchPage = useMemo(() => (server ? makeFetchPage(config) : undefined), [server, config]);
  const fetchRows = useMemo(
    () => (!server && !Array.isArray(rows) ? makeFetchRows(config) : undefined),
    [server, rows, config],
  );

  return (
    <RelationSelect
      value={value}
      selectedLabel={selectedLabel}
      onChange={onChange}
      columns={config.columns}
      getRowLabel={config.getRowLabel}
      fetchPage={fetchPage}
      fetchRows={fetchRows}
      rows={Array.isArray(rows) ? rows : undefined}
      title={title ?? config.title}
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      disabled={disabled}
      allowClear={allowClear}
      closeOnSelect={closeOnSelect}
      selectedValues={selectedValues}
      panelMinWidth={panelMinWidth}
      selectedCode={selectedCode}
      openToken={openToken}
    />
  );
}
